import { makeAutoObservable } from 'mobx';

import { PopupName } from 'src/constants';
import type {
  PopupConfirmState,
  PopupCreatePaymentState,
  PopupRecordPaymentState,
  PopupShareState,
  PopupWarnState,
  TGetPopupState,
} from 'src/interfaces';

type PopupState = Record<string, any>;
type IPopups = Record<PopupName, PopupState>;

class PopupStore {
  activePopup: PopupName | null = null;

  popups: IPopups = Object.values(PopupName).reduce(
    (popups, popupName) => ({
      ...popups,
      [popupName as PopupName]: this.getInitialPopupState(),
    }),
    {} as IPopups
  );

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  hidePopup(popupName: PopupName) {
    this.activePopup = null;
    this.popups[popupName] = this.getInitialPopupState();
  }

  showPopup(popupName: PopupName.CONFIRM, state: PopupConfirmState): void;
  showPopup(popupName: PopupName.CREATE_PAYMENT, state: PopupCreatePaymentState): void;
  showPopup(popupName: PopupName.SALES_FILTERS): void;
  showPopup(popupName: PopupName.PAYMENTS_FILTERS): void;
  showPopup(popupName: PopupName.PAYMENT_STATUS): void;
  showPopup(popupName: PopupName.RECORD_PAYMENT, state: PopupRecordPaymentState): void;
  showPopup(popupName: PopupName.SHARE, state: PopupShareState): void;
  showPopup(popupName: PopupName.WARN, state?: PopupWarnState): void;
  showPopup(popupName: PopupName, state: PopupState = {}) {
    this.activePopup = popupName;
    this.popups[popupName] = Object.assign({ isVisible: true }, state);
  }

  getPopupState(popupName: PopupName.CONFIRM): TGetPopupState<PopupConfirmState>;
  getPopupState(popupName: PopupName.CREATE_PAYMENT): TGetPopupState<PopupCreatePaymentState>;
  getPopupState(popupName: PopupName.RECORD_PAYMENT): TGetPopupState<PopupRecordPaymentState>;
  getPopupState(popupName: PopupName.SHARE): TGetPopupState<PopupShareState>;
  getPopupState(popupName: PopupName.WARN): TGetPopupState<PopupWarnState>;
  getPopupState(popupName: PopupName): TGetPopupState;
  getPopupState(popupName: PopupName) {
    return this.popups[popupName];
  }

  getInitialPopupState() {
    return {
      isVisible: false,
    };
  }
}

export default new PopupStore();
